import { GenderEnum } from '../../enums/common/gender.enum'
import { SchoolLevelEnum } from '../../enums/common/school-level.enum'
import { FamilyArrangementEnum } from '../../enums/ol/family-arrangement.enum'
import { JourneyLight } from '../product/journey'
import { TripLight } from '../trip/trip'

export type EnrollmentCenterGenderDistribution = Record<
  GenderEnum,
  { count: number; percentage: number }
>

export type EnrollmentCenterFamilyArrangementDistribution = Record<
  FamilyArrangementEnum,
  { count: number; percentage: number }
>

export type EnrollmentCenterSchoolLevelDistribution = Record<SchoolLevelEnum, number>

export type CenterFamilyAssignmentGroupDistribution = {
  withHostFamily: number
  percentageWithHostFamily: number
  total: number
}

export type CenterFamilyAssignmentsDistribution =
  | {
      isHostFamilyAccomodation: false
      affectedStaff: null
      enrollments: null
    }
  | {
      isHostFamilyAccomodation: true
      affectedStaff: CenterFamilyAssignmentGroupDistribution
      enrollments: CenterFamilyAssignmentGroupDistribution
    }

export type CenterJourneyDistribution = { journey: JourneyLight; value: number }

export enum AgeRange {
  EIGHT_TO_ELEVEN = 'EIGHT_TO_ELEVEN',
  TWELVE_TO_FOURTEEN = 'TWELVE_TO_FOURTEEN',
  FIFTEEN_TO_SEVENTEEN = 'FIFTEEN_TO_SEVENTEEN',
  EIGHTEEN_PLUS = 'EIGHTEEN_PLUS'
}

export const ageRangeMapping: Record<AgeRange, string> = {
  [AgeRange.EIGHT_TO_ELEVEN]: '8-11 ans',
  [AgeRange.TWELVE_TO_FOURTEEN]: '12-14 ans',
  [AgeRange.FIFTEEN_TO_SEVENTEEN]: '15-17 ans',
  [AgeRange.EIGHTEEN_PLUS]: '18 ans et plus'
}

export type EnrollmentCenterAgeDistribution = Record<AgeRange, number>

export type CenterTripDistribution = { trip: TripLight; count: number }
